// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__14OLx","error":"Textarea_error__29Sj5","readonly":"Textarea_readonly__2fjhL","disabled":"Textarea_disabled__3_e_R"};